// extracted by mini-css-extract-plugin
module.exports = {"container":"TournamentTile_container__36X0L","logo":"TournamentTile_logo__8u57b"};